import { useState, useEffect } from "react";
import { supabase } from "../lib/supabaseClient";

export default function EmailSettingsSection({ userId }: { userId: string }) {
  const [optIn, setOptIn] = useState(true);
  const [saving, setSaving] = useState(false);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    supabase
      .from("user_email_prefs")
      .select("marketing_opt_in")
      .eq("user_id", userId)
      .maybeSingle()
      .then(({ data }) => {
        setOptIn(data?.marketing_opt_in ?? true);
        setLoaded(true);
      });
  }, [userId]);

  const handleChange = async (val: boolean) => {
    setOptIn(val);
    setSaving(true);
    await supabase
      .from("user_email_prefs")
      .upsert(
        { user_id: userId, marketing_opt_in: val, max_per_day: 3 },
        { onConflict: "user_id" }
      );
    setSaving(false);
  };

  if (!loaded) return null;

  return (
    <div className="bg-[#161b27] border border-[#2a3347] rounded-xl p-4 mt-6">
      <h2 className="text-lg font-semibold mb-2 text-slate-100">✉️ E-Mail-Einstellungen</h2>
      <p className="text-sm text-slate-400 mb-4">
        Wähle aus, welche E-Mails du von uns erhalten möchtest.
      </p>
      <label className="flex justify-between items-center mb-3">
        <span className="text-slate-200">Onboarding- und Tipp-E-Mails</span>
        <input
          type="checkbox"
          checked={optIn}
          onChange={(e) => handleChange(e.target.checked)}
          disabled={saving}
          className="w-5 h-5"
        />
      </label>
    </div>
  );
}
